import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DownloadFile = function DownloadFile(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25 19H23V35H25V19Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 36.4125L17.6875 30.1L19.1 28.6875L24 33.5875L28.9 28.6875L30.3125 30.1L24 36.4125Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M31 38H17V40H31V38Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M42 45H6V4H30.4125L42 15.5875V45ZM8 43H40V16.4125L29.5875 6H8V43Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M41 17H29V5H31V15H41V17Z",
      fill: color
    })]
  });
};
export default DownloadFile;